import { userFacingNameString } from "./account-status-display-name";
import { SnapIcon, SnapTable } from "suit";

type VaultEntityType = "kyb" | "representative" | "beneficialOwners";

type DocumentStatusProps = {
  kybRequirements?: [string, string, string][];
  accountRepresentativeRequirements?: [string, string, string][];
  beneficialOwnersRequirements?: [string, string, string][];
  onDocumentChange: (documentParams: {
    documentName: string;
    unitId?: string;
    ownerName?: string;
  }) => void;
  onVaultEntityTypeChange: (entityType: VaultEntityType) => void;
  fileUploadStatuses: { documentOwner?: string; documentName: string }[];
};

type DocumentStatusRowProps = {
  documentName: string;
  onClick: () => void;
  isUploaded: boolean;
  ownerName?: string;
};

function DocumentStatusRow({
  documentName,
  onClick,
  isUploaded,
  ownerName,
}: DocumentStatusRowProps) {
  return (
    <tr className="flex md:table-row cursor-pointer" onClick={onClick}>
      <td className="text-blue-600 hover:underline">
        {userFacingNameString(documentName, ownerName)}
      </td>
      <td className="w-5 md:w-auto text-center">
        <SnapIcon
          icon={isUploaded ? "check-circle-solid" : "circle-empty-solid"}
          color={isUploaded ? "green" : "grey"}
        />
      </td>
    </tr>
  );
}

export default function DocumentStatus({
  kybRequirements = [],
  accountRepresentativeRequirements = [],
  beneficialOwnersRequirements = [],
  onDocumentChange,
  onVaultEntityTypeChange,
  fileUploadStatuses,
}: DocumentStatusProps) {
  return (
    <SnapTable className="w-full">
      <table className="ui celled table">
        <thead>
          <tr>
            <th>File Type</th>
            <th className="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          {kybRequirements.map(([documentName, unitId], index: number) => (
            <DocumentStatusRow
              documentName={documentName}
              key={index}
              onClick={() => {
                onVaultEntityTypeChange("kyb");
                onDocumentChange({ documentName, unitId });
              }}
              isUploaded={fileUploadStatuses.some(
                (fus) => fus.documentName === documentName && !fus.documentOwner
              )}
            />
          ))}
          {accountRepresentativeRequirements.map(
            ([documentName, unitId, ownerName], index: number) => (
              <DocumentStatusRow
                documentName={documentName}
                ownerName={ownerName}
                key={index}
                onClick={() => {
                  onVaultEntityTypeChange("representative");
                  onDocumentChange({ documentName, unitId, ownerName });
                }}
                isUploaded={fileUploadStatuses.some(
                  (fus) =>
                    fus.documentName === documentName &&
                    (!fus.documentOwner || fus.documentOwner === ownerName)
                )}
              />
            )
          )}
          {beneficialOwnersRequirements.map(
            ([documentName, unitId, ownerName], index: number) => (
              <DocumentStatusRow
                documentName={documentName}
                ownerName={ownerName}
                key={index}
                onClick={() => {
                  onVaultEntityTypeChange("beneficialOwners");
                  onDocumentChange({ documentName, unitId, ownerName });
                }}
                isUploaded={fileUploadStatuses.some(
                  (fus) =>
                    fus.documentName === documentName &&
                    (!fus.documentOwner || fus.documentOwner === ownerName)
                )}
              />
            )
          )}
        </tbody>
      </table>
    </SnapTable>
  );
}
